import { useMemo } from 'react';

import DifferentiationShape from 'approot/shared/differentiation/differentiation-shape';
import { ScreenReaderOnly } from 'approot/shared/styles/global.styles';
import { getActivityDetails, getActivityNumber } from './activity.utils';
import { Props } from './activity-print.constants';
import * as Styled from './activity-print.style';

const ActivityPrint = ({
  section,
  sectionsOverview,
  hideCheckpoint,
}: Props) => {
  const {
    totalSteps,
    differentiation,
    parentSectionId,
    progressLabel,
    isCheckPoint,
  } = useMemo(() => {
    return getActivityDetails({
      section,
      sectionsOverview,
    });
  }, [section, sectionsOverview]);

  const number = useMemo(() => {
    return getActivityNumber(parentSectionId || '', sectionsOverview);
  }, [parentSectionId, sectionsOverview]);

  return (
    <Styled.ActivityPrint>
      <ScreenReaderOnly as="h1">
        {`Activity ${number}${totalSteps > 1 ? ` (${progressLabel})` : ''}`}
      </ScreenReaderOnly>
      {differentiation && (
        <Styled.ActivityPrintDifferentiation aria-hidden>
          {isCheckPoint && !hideCheckpoint && (
            <Styled.ActivityPrintCheckpoint
              id="icon_star"
              $isActive
              width={18}
              height={18}
            />
          )}
          <DifferentiationShape
            differentiation={differentiation}
            number={number}
            width={32}
            height={32}
          />
        </Styled.ActivityPrintDifferentiation>
      )}
      {totalSteps > 1 && (
        <Styled.ActivityPrintText aria-hidden>
          {progressLabel}
        </Styled.ActivityPrintText>
      )}
    </Styled.ActivityPrint>
  );
};

export default ActivityPrint;
